import findLastIndex from 'lodash/findLastIndex';
import cloneDeep from 'lodash/cloneDeep';

import CartStore, { productsForOrder, ProductsRemovedFromCart } from '../store/cart';
import { HasShownMaxQuantityStore } from '../store/maxQuantity';

import { getProductInfo, addToCart, removeFromCart, getCartProductInfo } from './analytics';
import { cartPrice } from '../store/cart';
import {
  findGiftProducts,
  transformToFullPageCartItems,
  transformProducts,
  mergeEntriesWithProductQuantity,
} from '@/utils/products/products';
import { arraysEqual } from './helpers';

export const MAX_CART_VOLUME = 600;

export function onAddProductsUpdate(productQuantity, productAdded) {
  const currentProducts = productsForOrder.getValue();
  const orderProducts = currentProducts || [];
  if (productQuantity === 0) {
    productsForOrder.update([productAdded, ...orderProducts]);
  } else {
    const newItems = Array(productQuantity).fill(productAdded);
    productsForOrder.update([...currentProducts, ...newItems]);
  }
}

export function addRegularProduct(product, isProductMYO, configDefaultOption, quantity = 0, productLimit = 6) {
  if (product?.stepToUom * quantity <= productLimit || !productLimit) {
    // if (!isProductMYO) {

    onAddProductsUpdate(quantity, product);

    // }
    // const productWithOptions = product.options ? product : { ...product, options: [configDefaultOption] };
    // onAddProductsUpdate(quantity, productWithOptions);
  }
}

export function onClickAddToOrder(
  product,
  productLimit,
  configDefaultOption,
  quantity = 1,
  isProductMYO = false,
  analyticsOverrides
) {
  const qty = quantity <= 0 ? 1 : quantity;
  addRegularProduct(product, isProductMYO, configDefaultOption, qty, product?.quantityLimit);

  let unitPrice = 0;

  if (product?.price) {
    unitPrice = parseFloat(product?.price);

    if (product.ingredients && product.ingredientsGroups) {
      let additionalPrice = 0;
      for (const ingredient of product.ingredients) {
        for (const group of product.ingredientsGroups) {
          if (group.priceCalculationType === 'ADDITIONAL_TO_THE_PRICE') {
            const option = group.options.find(o => o.id === ingredient);
            if (option) additionalPrice += option.additionalPrice.value;
          }
        }
      }
      unitPrice += additionalPrice / 100;
    }
  } else {
    unitPrice = product?.isWeighed
      ? parseFloat(product?.finalPrice / 100) * product?.stepToUom
      : parseFloat(product?.finalPrice / 100);
  }

  const totalPriceIncrease = unitPrice * qty;
  const currentCartPrice = parseFloat(cartPrice.getValue() || 0);
  const newCartPrice = (currentCartPrice + totalPriceIncrease).toFixed(2);

  addToCart(getCartProductInfo(product, analyticsOverrides));
  cartPrice.update(newCartPrice);
}
export function onClickRemoveItem(product) {
  const currProducts = productsForOrder.getValue() || [];
  const tempProducts = currProducts.filter(p => p._id !== product._id);
  productsForOrder.update(tempProducts);
}

export function onClickRemoveFromOrder(product, analyticsOverrides, quantity = 1) {
  const productMYO = !!product?.myoId;
  const productWithIngredients = !!product?.ingredients;
  let tempProducts = [...productsForOrder.getValue()];

  let currentTotal = Math.round(parseFloat(cartPrice.getValue()) * 100);

  for (let i = 0; i < quantity; i++) {
    let id;
    let lastIndex;

    if (productMYO) {
      id = product.myoId;
      lastIndex = findLastIndex(tempProducts, p => p.myoId === id);
    } else if (productWithIngredients) {
      id = product.id;
      lastIndex = findLastIndex(
        tempProducts,
        p => p.id === id && arraysEqual(p.ingredients || [], product.ingredients)
      );
    } else {
      id = product?.id ? product.id : product?._id;
      lastIndex = findLastIndex(tempProducts, p => p.id === id);
    }

    if (lastIndex !== -1) {
      tempProducts.splice(lastIndex, 1);

      let itemPriceCents = 0;

      if (product?.price) {
        itemPriceCents = Math.round(parseFloat(product.price) * 100);

        if (product.ingredients && product.ingredientsGroups) {
          let additionalCents = 0;
          for (const ingredient of product.ingredients) {
            for (const group of product.ingredientsGroups) {
              if (group.priceCalculationType === 'ADDITIONAL_TO_THE_PRICE') {
                const option = group.options.find(o => o.id === ingredient);
                if (option) {
                  additionalCents += option.additionalPrice.value;
                }
              }
            }
          }
        }
      } else {
        itemPriceCents = Math.round(parseFloat(product?.finalPrice));
      }
      currentTotal -= itemPriceCents;
    }
  }
  productsForOrder.update(tempProducts);
  cartPrice.update(currentTotal / 100);

  removeFromCart(getCartProductInfo(product, analyticsOverrides));
}

export function clearCart() {
  productsForOrder.update([]);
  ProductsRemovedFromCart.update([]);
  // CartStore.setIsVisible(false);
  HasShownMaxQuantityStore.clear();
  cartPrice.update('0.00');
}

export function addGiftsToFullPageCart(order, allProducts, bundleOffersSummary, noCommentToken, t) {
  let giftQuantitiess,
    newAllProducts = null;
  if (order.order?.freeProducts?.length > 0) {
    const gifts = order.order.freeProducts;
    const { filteredGifts, giftQuantities, inCatalogueGifts, inCatalogueGiftsQuantities } = findGiftProducts(
      order.products,
      order.order.freeProducts
    );
    giftQuantitiess = inCatalogueGiftsQuantities;
    const freeproducts = transformToFullPageCartItems(
      filteredGifts,
      order.order,
      true,
      true,
      giftQuantities,
      1,
      noCommentToken,
      t
    );
    let mockOrderCheckResponse = cloneDeep(order);
    mockOrderCheckResponse.order.products = inCatalogueGifts;
    const inCatGifts = transformProducts(
      mockOrderCheckResponse,
      bundleOffersSummary,
      true,
      undefined,
      noCommentToken,
      undefined,
      undefined,
      t
    );
    newAllProducts = [...inCatGifts, ...allProducts];
    newAllProducts = mergeEntriesWithProductQuantity(newAllProducts, true);
    newAllProducts = [...freeproducts, ...newAllProducts];
  }
  return { giftQuantitiess, newAllProducts };
}

// export function mergeProductArrays(array1, array2) {
//   const mergedMap = new Map();

//   function generateKey(product) {
//     return product.productId + (product.options.length > 0 ? `_${product.options[0]}` : '');
//   }

//   function addToMap(product) {
//     const key = generateKey(product);
//     if (mergedMap.has(key)) {
//       mergedMap.get(key).quantity += product.quantity;
//     } else {
//       mergedMap.set(key, { ...product });
//     }
//   }

//   array1.forEach(addToMap);
//   array2.forEach(addToMap);

//   return Array.from(mergedMap.values());
// }

export function mergeProductArrays(array1, array2) {
  const mergedMap = new Map();

  function generateKey(product) {
    return product.productId + (product.options.length > 0 ? `_${product.options[0]}` : '');
  }

  // First add everything from array1
  array1.forEach(product => {
    const key = generateKey(product);
    mergedMap.set(key, { ...product });
  });

  // Then override with products from array2 (quantity from array2 takes precedence)
  array2.forEach(product => {
    const key = generateKey(product);
    mergedMap.set(key, { ...product });
  });

  return Array.from(mergedMap.values());
}

export default {
  onClickAddToOrder,
  onClickRemoveFromOrder,
  onClickRemoveItem,
  clearCart,
  MAX_CART_VOLUME,
  addRegularProduct,
  onAddProductsUpdate,
  addGiftsToFullPageCart,
  mergeProductArrays,
};
